/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Preamp } from '@red-digital/bricks';

interface Props {
  placement: string;
  components: {
    [key: string]: JSX.Element;
  };
  dependencies?;
}

interface ComponentProps {
  order?: string;
  enabled?: string;
}

interface Data {
  [key: string]: ComponentProps;
}

const sortComponents = (data: Data = {}) => {
  const dataArr = Object.entries(data);

  const sortedComponents = dataArr
    .sort((a, b) => {
      const [_aKey, aData] = a;
      const [_bKey, bData] = b;

      const aPos = Number(aData.order);
      const bPos = Number(bData.order);

      if (aPos < bPos) return -1;
      if (aPos > bPos) return 1;
      return 0;
    })
    .filter(([_, { enabled }]) => enabled !== 'false');

  return sortedComponents;
};

const PreampPageBuilder: React.FC<Props> = ({ components, ...rest }) => {
  return (
    <Preamp {...rest}>
      {(data: Data) => {
        const sortedComponents = sortComponents(data);

        if (sortedComponents?.length) {
          return (
            <>
              {sortedComponents.map(([componentKey, props], index) => {
                const component = components[componentKey];
                if (React.isValidElement(component)) {
                  return (
                    <React.Fragment key={index}>
                      {React.cloneElement(component, props)}
                    </React.Fragment>
                  );
                }
                return null;
              })}
            </>
          );
        }

        const defaultComponents = Object.entries(components);

        return (
          <>
            {defaultComponents.map(([componentKey, component], index) => {
              const { enabled } = component?.props || {};
              if (!component || enabled === 'false') return null;
              return <React.Fragment key={index}>{component}</React.Fragment>;
            })}
          </>
        );
      }}
    </Preamp>
  );
};

PreampPageBuilder.displayName = 'PreampPageBuilder';

export default PreampPageBuilder;
